import { CheckCircle2 } from "lucide-react"
import React, { type ChangeEvent } from "react"
import BackIcon from "@/assets/icons/misc/back-icon.tsx"
import SearchBarGeneral from "@/components/search-bar/search-bar-general.tsx"
import styles from "@/components/shadcn/drawer/custom-drawer.module.css"
import { DrawerClose } from "@/components/shadcn/drawer.tsx"

interface DrawerTopBarProps {
  searchQuery: string
  setSearchQuery: (searchQuery: string) => void
  placeholder: string
  onSaveClick?: () => void
}

const DrawerTopBar: React.FC<DrawerTopBarProps> = ({
  searchQuery,
  setSearchQuery,
  placeholder,
  onSaveClick,
}) => {
  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }
  return (
    <div className={styles["slide-up-top-bar"]}>
      <DrawerClose asChild>
        <BackIcon />
      </DrawerClose>
      <SearchBarGeneral
        value={searchQuery}
        onChange={handleSearchInputChange}
        placeholder={placeholder}
      />
      <DrawerClose asChild onClick={onSaveClick}>
        <CheckCircle2
          data-testid="drawer-confirm-selection"
          className="h-[30px] w-[30px] cursor-pointer text-brown-500 transition-colors [@media(hover:hover)]:hover:text-green-500"
        />
      </DrawerClose>
    </div>
  )
}

export default DrawerTopBar
